import React from "react";
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";

// Define styles for the map container
const containerStyle = {
  width: "100vw", // Full viewport width
  height: "100vh", // Full viewport height
};

// Set the initial center position for the map (Delhi, India)
const center = {
  lat: 28.6448,
  lng: 77.216721,
};

function StoreLocator() {
  // Load Google Maps API using the useJsApiLoader hook
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyA08TJWvLGvDD4cXLo-231gioXgaugKUw0", // Replace with your actual API key
  });

  // Define marker locations with latitude, longitude, and titles
  let markers = [
    {
      name: "marker2",
      position: { lat: 28.6060, lng: 77.4297 }, // Location near Delhi
      title: "Livasa Natural",
    },
    {
      name: "marker3",
      position: { lat: 13.038969, lng: 77.652069 }, // Location in Bangalore
      title: "Livasa Natural",
    },
  ];

  // Render the Google Map only when the API is fully loaded
  return isLoaded ? (
    <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={4}>
      {/* Map through the markers array and place each marker on the map */}
      {markers.map((marker, index) => (
        <Marker
          key={index} // Unique key for each marker
          name={marker.name}
          position={marker.position} // Marker coordinates
          title={marker.title} // Tooltip text
        />
      ))}
    </GoogleMap>
  ) : (
    <></> // Return an empty fragment while the map is loading
  );
}

// Use React.memo to optimize performance by preventing unnecessary re-renders
export default React.memo(StoreLocator);
